import { baseURL } from './http.js';
import request from './request.js';

export default {
  // 样品列表
  getSampleList: item => request(baseURL).post('sample/list', item),
  getSampleDetail: val => request(baseURL).get(`sample/get?id=${val}`),
  deleteSample: item => request(baseURL).post('sample/deleteByIds', item),
  withdrawSample: item => request(baseURL).post('sample/batchRecall', item),
  batchSubmitSample: item => request(baseURL).post('sample/batchSubmit', item),
  createSampleCheck: item => request(baseURL).post('sampleCheck/create', item),
  batchSamplePuton: item => request(baseURL).post('sample/batchPutOn', item),
  batchSamplePutoff: item => request(baseURL).post('sample/batchTakeOff', item),
  // 包材
  createPackingMaterialSample: item => request(baseURL).post('sample/createPackingMaterial', item),
  updatePackingMaterialSample: item => request(baseURL).post('sample/updatePackingMaterial', item),
  getPackingMaterialSample: val => request(baseURL).get(`packingMaterialSample/get?id=${val}`),
  batchImportPackingMaterialSample: item => request(baseURL).post('sample/batchImportPackingMaterial', item),
  // ODM样品
  createODMSample: item => request(baseURL).post('sample/createODM', item),
  updateODMSample: item => request(baseURL).post('sample/updateODM', item),
  getODMSample: val => request(baseURL).get(`odmSample/get?id=${val}`),
  batchImportODMSample: item => request(baseURL).post('sample/batchImportODM', item),
  // 赠品
  getGiftListPage: item => request(baseURL).post('sample/giftListPage', item),
  getGIFTSample: val => request(baseURL).get(`giftMaterialSample/get?id=${val}`),
  createGiftSample: item => request(baseURL).post('sample/createGiftMaterial', item),
  updateGiftSample: item => request(baseURL).post('sample/updateGiftMaterial', item),
  batchImportGiftSample: item => request(baseURL).post('sample/batchImportGift', item),
  
  // 膜布
  createFabric: item => request(baseURL).post('sample/createFabric', item),
  updateFabric: item => request(baseURL).post('sample/updateFabric', item),
  getFabric: val => request(baseURL).get(`fabricSample/get?id=${val}`),
  batchImportFabricSample: item => request(baseURL).post('sample/batchImportFabric', item),
  // 原料
  createRawMaterial: item => request(baseURL).post('sample/createRawMaterial', item),
  updateRawMaterial: item => request(baseURL).post('sample/updateRawMaterial', item),
  getRawMaterial: val => request(baseURL).get(`rawMaterialSample/get?id=${val}`),
  batchImportRawMaterial: item => request(baseURL).post('sample/batchImportRawMaterial', item),
  // 是否被水羊启用过修改
  updateShuiyangEnable: val => request(baseURL).get(`sample/updateShuiyangEnable?${val}`),
};